import { useSortable } from '@dnd-kit/sortable';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge, Card, Col } from 'react-bootstrap';
import CSS from '../../utils/utilities';
import './style.scss';

const SortableItem = ({ item, id, order }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  return (
    <Col md={12}>
      <Card className="life-cycle-item text-center" ref={setNodeRef} style={style} {...attributes} {...listeners}>
        <Card.Header>
          <h4>
            <Badge variant="danger">{`${order} - ${item.life_value}`}</Badge>
          </h4>
        </Card.Header>
        <Card.Body>
          <Card.Text>
            {item.question}
          </Card.Text>
        </Card.Body>
      </Card>
    </Col>

  );
};

SortableItem.propTypes = {
  item: PropTypes.shape({
    life_value: PropTypes.string,
    question: PropTypes.string
  }).isRequired,
  id: PropTypes.number.isRequired,
  order: PropTypes.number.isRequired
};

export default SortableItem;
